var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlame(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4408 1.5803C10.8092 1.42305 11.2359 1.50081 11.5251 1.77791C12.2702 2.49168 13.2236 4.07755 13.697 5.89742C14.1032 7.45931 14.193 9.34439 13.3613 11.089C13.5124 11.1264 13.6221 11.1049 13.7234 11.0661C14.1134 10.9168 14.7776 10.3512 15.8173 8.67808C15.9818 8.41343 16.2602 8.24056 16.5704 8.21056C16.8805 8.18055 17.1869 8.29683 17.3991 8.52504C18.0547 9.23032 18.6929 10.3108 19.1648 11.4067C19.6338 12.4957 20 13.7417 20 14.7941C20 16.8521 19.1462 18.8165 17.6415 20.258C16.1383 21.6981 14.1082 22.5 12 22.5C9.89179 22.5 7.86174 21.6981 6.35848 20.258C4.85376 18.8165 4 16.8521 4 14.7941C4 12.564 5.00707 10.0929 6.63175 8.49332L6.63233 8.49275C6.67011 8.45562 6.70807 8.41835 6.74619 8.38093C8.18162 6.97199 9.83333 5.35074 9.83333 2.50002C9.83333 2.09946 10.0724 1.73755 10.4408 1.5803ZM11.3803 5.26599C10.6609 7.35054 9.23432 8.74541 8.21382 9.74326C8.15265 9.80308 8.09293 9.86147 8.03491 9.9185C6.79893 11.1354 6 13.0901 6 14.7941C6 16.2932 6.62124 17.7401 7.74203 18.8138C8.86427 19.8889 10.3952 20.5 12 20.5C13.6048 20.5 15.1357 19.8889 16.258 18.8138C17.3788 17.7401 18 16.2932 18 14.7941C18 14.1343 17.7502 13.1786 17.3279 12.1977C17.1345 11.7486 16.9179 11.3243 16.6969 10.9503C15.9521 11.9546 15.2238 12.6333 14.4384 12.9339C13.197 13.4092 12.1635 12.8467 11.379 12.225C10.9631 11.8954 10.877 11.2984 11.1828 10.8648C12.1183 9.5385 12.1568 7.92107 11.7614 6.40087C11.6566 5.99822 11.5251 5.61689 11.3803 5.26599Z",
    fill: "url(#paint0_linear_3959_18847)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3959_18847",
    x1: 4,
    y1: 12.0503,
    x2: 20,
    y2: 12.0503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6366F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8B5CF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D946EF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlame);
export default __webpack_public_path__ + "static/media/flame.3fd9182ed644b67a88fca6f4ba8f5d98.svg";
export { ForwardRef as ReactComponent };